import React from 'react'
import {BiCameraMovie} from 'react-icons/bi'
import { useGlobalContext } from '../context'
import {Link} from 'react-router-dom'

const SEARCHAPI ="https://api.themoviedb.org/3/search/movie?&api_key=9e6cb54fb7368ab503a406230cc63f3a&query=";

const Navbar = () => {
    const {searchValue,setSearch,fetchMovie,search} = useGlobalContext()

    const handleSubmit = (e) =>{
        e.preventDefault()
        
    }
    return (
        <>
        <div className="nav_main">
            <div className="nav_container">
                <div className="logo_nav">
                   <Link to='/' className='link_item'><h2>MovieCorn <span><BiCameraMovie/></span></h2></Link>
                </div>
                <div className="search_nav">
                    <div className="nav_link">
                        <ul>
                            <li className='link_item'>
                                <Link to="/" className='link_item'>Home</Link>
                            </li>
                            <li className='link_item'>
                                <Link to="/about" className='link_item'>About</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>  
        </div>
            
        </>
    )
}
export default Navbar
